module.exports = __webpack_public_path__ + "static/logo-tropical-0d5078b0afa90d88a42dfde0f220bb00.png";